import { loadScript } from './loadScript'

interface ITelegramWebApp {
  initData: string
  ready: () => void
  expand: () => void
  // с Bot API 7.7, у старых клиентов метода нет
  disableVerticalSwipes?: () => void
}

declare global {
  interface Window {
    Telegram?: { WebApp?: ITelegramWebApp }
  }
}

const TELEGRAM_SCRIPT_URL = 'https://telegram.org/js/telegram-web-app.js'
// внутри мини-приложения telegram.org заведомо доступен, а в обычном браузере
// скрипт всё равно ничего не даёт — дольше держать показ кабинета незачем
const TIMEOUT_MS = 3000

export const loadTelegramWebApp = (): Promise<void> =>
  loadScript(TELEGRAM_SCRIPT_URL, TIMEOUT_MS)

// Скрипт Telegram отдаёт объект и в обычном браузере, но initData там пустой
export const getTelegramWebApp = (): ITelegramWebApp | undefined => {
  const webApp = window.Telegram?.WebApp

  return webApp?.initData ? webApp : undefined
}

export const initTelegramWebApp = async (): Promise<void> => {
  await loadTelegramWebApp()
  const webApp = getTelegramWebApp()
  if (!webApp) return

  webApp.ready()
  // из кнопки меню бота приложение открывается на половину экрана,
  // и вёрстка кабинета сжимается вдвое вместе с ним
  webApp.expand()
  // иначе протяжка страницы вниз закрывает приложение вместо прокрутки
  webApp.disableVerticalSwipes?.()
}
